import { ChangeDetectionStrategy, Component } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Event, Router, Scroll } from '@angular/router'
import { environment } from '@appEnvironments/environment'

@Component({
    selector: 'app-site-footer',
    templateUrl: './site-footer.component.html',
    styleUrls: ['./site-footer.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})

export class SiteFooterComponent {
   currentYear = (new Date()).getFullYear()
   hideFooter: boolean
   contactUsUri = environment.contactUsUri

   constructor(
      private _router: Router
   ) {

      this._router.events
         .pipe(takeUntilDestroyed())
         .subscribe((event: Event) => {
            if (event instanceof Scroll) {
               const url = event?.routerEvent?.url
               this.hideFooter = url.includes('registration-landing')
            }
         })
   }
}
